/**
 * Conversions XP <-> niveau, miroir de la fonction Postgres `_level_from_xp`.
 *
 * Courbe : xp_required(level) = 100 * level^1.5 (XP nécessaire pour
 * franchir le niveau N depuis le niveau N).
 * Le seuil cumulé pour atteindre le niveau N est la somme des coûts des
 * niveaux 1..N-1.
 */
const MAX_LEVEL = 200;
function costForLevel(level) {
    return Math.round(100 * Math.pow(level, 1.5));
}
function thresholdForLevel(level) {
    let total = 0;
    for (let k = 1; k < level; k++) {
        total += costForLevel(k);
    }
    return total;
}
export function levelProgress(xp, level) {
    const safeLevel = Math.max(1, Math.min(MAX_LEVEL, level));
    const thresholdCurrent = thresholdForLevel(safeLevel);
    const xpForNextLevel = costForLevel(safeLevel);
    const thresholdNext = thresholdCurrent + xpForNextLevel;
    const xpInLevel = Math.max(0, xp - thresholdCurrent);
    const percent = Math.max(0, Math.min(100, (xpInLevel / xpForNextLevel) * 100));
    return {
        level: safeLevel,
        xp,
        xpInLevel,
        xpForNextLevel,
        thresholdCurrent,
        thresholdNext,
        percent,
    };
}
